import React, { useState, useEffect } from "react"
import { Button, Col, Form, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import toast from "react-hot-toast"
import Select from "react-select"
import { Select as SearchBox } from "antd"

// api
import { getAllBranches } from "../../../Helpers/apiCalls/Purchases/purchaseOrderApi"

// assets & styles
import {
  antdesignSelectStyle,
  formatDecimal,
  numberFormat,
  toastStyle,
} from "../../../Helpers/Utils/Common"
import trash from "./../../../Assets/Images/trash.png"
import Navbar from "../../../Components/Navbar/Navbar"
import { Fragment } from "react"
import { getAllSaleItemsByBranch } from "../../../Helpers/apiCalls/franchiseeApi"
import InputError from "../../../Components/InputError/InputError"
import ReactLoading from "react-loading"
import {
  getSalesQuotation,
  updateSalesQuotation,
} from "../../../Helpers/apiCalls/SalesModule/SalesQuotationApi"
import { Upload } from "antd"
import upload from "../../../Assets/Images/upload.png"
import {
  createSalesOrder,
  getSalesOrder,
} from "../../../Helpers/apiCalls/SalesModule/SalesOrderApi"
import { getCustomer } from "../../../Helpers/apiCalls/Manage/CustomersApi"
import { getAllBanks } from "../../../Helpers/apiCalls/banksAPi"
import { getAllEmployees } from "../../../Helpers/apiCalls/employeesApi"
import {
  createSalesInvoice,
  getSalesInvoice,
  updateSalesInvoice,
} from "../../../Helpers/apiCalls/SalesModule/SalesInvoiceApi"
import Footer from "../../../Components/Footer/Footer"
import Modal from "antd/es/modal/Modal"
import FileExceedModal from "../../../Components/Modals/FileExceedModal"
import Compressor from "compressorjs"
import noDataImg from "../../../Assets/Images/no-data-img.png"
import {
  validateSalesInvoice,
  validateSalesInvoiceItems,
} from "../../../Helpers/Validation/Sales/SalesValidation"
import { getItemPriceByBranch } from "../../../Helpers/apiCalls/Manage/ItemPrice"
const { Dragger } = Upload

function SalesInvoiceForm({ add, edit }) {
  const { id } = useParams()
  let navigate = useNavigate()
  const [itemError, setItemError] = useState({})
  const [inactive, setInactive] = useState(true)
  const [isChanged, setIsChanged] = useState(false)
  const [isClicked, setIsClicked] = useState(false)
  const [addDetails, setAddDetails] = useState({
    customer_po_no: null,
    delivery_fee: 0,
    service_fee: 0,
    paid_amount: 0,
  })
  const [orderItems, setOrderItems] = useState([])
  const [fileList, setFileList] = useState([])
  const [file, setFile] = useState([])
  const [quotations, setQuotations] = useState([])

  // DATA HANDLERS
  const [banks, setBanks] = useState([])
  const [customers, setCustomers] = useState([])
  const [branches, setBranches] = useState([])
  const [employees, setEmployees] = useState([])
  const [allItems, setAllItems] = useState([])
  const [filteredItems, setFilteredItems] = useState([])
  const [prices, setPrices] = useState([])
  // const [exceed, setExceed] = useState(false);
  const [additionalItemList, setAdditionalItemList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")
  const [prevAttachments, setPrevAttachments] = useState([])
  const [showFileExceedModal, setShowFileExceedModal] = useState(false)

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    franchisee_id: false,
    address: false,
    delivery_date: false,
    seller_branch_id: false,
    sales_invoice_no: false,
    list: false,
    item_id: false,
    qty: false,
    qty2: false,
    invoice_no: false,
  })

  function handleSelectChange(e) {
    var newList = { ...addDetails }
    newList[e.name] = e.value
    newList[e.value_variable] = {
      label: e.label,
      value: e.value,
      name: e.name,
    }
    if (e.name === "quotation_id") {
      e.paid_amount = 0
      e.discount_total = 0
      e.quotation_id_value = {
        name: "quotation_id",
        value_variable: "quotation_id_value",
        label: "Quotation No." + e.id,
        value: e.id,
      }
      e.customer_id_value = {
        name: "customer_id",
        value_variable: "customer_id_value",
        label: e.customer_name,
        value: e.customer_id,
      }
      e.branch_id_value = {
        name: "branch_id",
        value_variable: "branch_id_value",
        label: e.branch_name,
        value: e.branch_id,
      }
      setAddDetails(e)
      setPrices([])
      var items = e.sales_quotation_items.map((data) => {
        var info = data
        info.price = data.price
        info.discount = 0
        info.price_value = {
          name: "price",
          label: data.price,
          value: data.price,
        }
        info.item_id_value = {
          name: "item_id",
          for: "item_id_value",
          label: data.item_name,
          value: data.item_id,
        }
        allItems.map((item) => {
          if (item.id === data.id) {
            info.item_name = item.item_name
            info.item_unit_id = item.item_unit_id
            info.id = item.item_id
            info.unit = item.unit
            info.wholesale_price = item.wholesale_price
            info.retail_price = item.retail_price
            info.special_price_1 = item.special_price_1
            info.special_price_2 = item.special_price_2
            info.special_price_3 = item.special_price_3
            info.cost_price = item.cost_price
            info.current_qty = item.current_qty

            if (
              item.wholesale_price !== null &&
              item.wholesale_price !== "0.0000"
            ) {
              prices.push({
                name: "price",
                label: item.wholesale_price,
                value: item.wholesale_price,
              })
            }
            if (item.retail_price !== null && item.retail_price !== "0.0000") {
              prices.push({
                name: "price",
                label: item.retail_price,
                value: item.retail_price,
              })
            }
            if (
              item.special_price_1 !== null &&
              item.special_price_1 !== "0.0000"
            ) {
              prices.push({
                name: "price",
                label: item.special_price_1,
                value: item.special_price_1,
              })
            }
            if (
              item.special_price_2 !== null &&
              item.special_price_2 !== "0.0000"
            ) {
              prices.push({
                name: "price",
                label: item.special_price_2,
                value: item.special_price_2,
              })
            }
            if (
              item.special_price_3 !== null &&
              item.special_price_3 !== "0.0000"
            ) {
              prices.push({
                name: "price",
                label: item.special_price_3,
                value: item.special_price_3,
              })
            }
            if (item.cost_price !== null && item.cost_price !== "0.0000") {
              prices.push({
                name: "price",
                label: item.cost_price,
                value: item.cost_price,
              })
            }
            setPrices(prices)
          }
        })
        return info
      })
      setOrderItems(items)
      var _subtotal = items
        .map((item) => parseFloat(item.subtotal))
        .reduce((a, b) => a + b, 0)
      setAddDetails((prev) => {
        return {
          ...prev,
          subtotal: _subtotal.toFixed(2),
        }
      })
    } else {
      setAddDetails(newList)
    }
  }

  function handleAddChange(e) {
    setIsChanged(true)
    const { name, value, checked } = e.target
    if (name === "is_vat") {
      setAddDetails((prevState) => ({
        ...prevState,
        [name]: checked,
        ["vat_type"]: checked ? "VAT" : "NVAT",
        ["withholding_percentage"]: !checked
          ? 0
          : addDetails.original_withholding_percentage,
      }))
    } else if (name === "withholding_percentage") {
      setAddDetails((prevState) => ({
        ...prevState,
        ["withholding_percentage"]: value === "1" ? 1 : 2,
      }))
    } else {
      const newList = { ...addDetails }
      newList[name] = value
      setAddDetails(newList)
    }
    setTimeout(() => setIsChanged(false), 10)
  }

  /**
   *  ORDER ITEMS
   */
  function addNewOrder() {
    const newItem = {
      qty: "1",
      unit: "",
      name: "",
      qty_received: 0,
      item_id: "",
      priceValue: "",
      price: "0.00",
      unit_discount: "0.00",
      total: "0.00",
      discount: 0,
      amount: "0",
      discount_percentage: 0,
      discount_amount: 0,
    }
    setOrderItems((oldItems) => [...oldItems, newItem])
  }
  function deleteOrder(row) {
    setIsChanged(true)

    //
    const updatedOrderList = [...orderItems]
    updatedOrderList.splice(row, 1)
    setOrderItems(updatedOrderList)

    const filteredOptions = allItems.filter((option) => {
      return !updatedOrderList.find((item) => item.item_id === option.item_id)
    })
    setFilteredItems(filteredOptions)

    setTimeout(() => setIsChanged(false), 10)
  }

  function handleOrderItemsChange(e, row, type) {
    setIsChanged(true)
    var temp = orderItems
    if (type === "item_id") {
      var item_name = allItems.filter((data) => {
        return data.value === e
      })
      temp[row].is_old_item = false
      temp[row].item_id = item_name[0].value
      temp[row].item_name = item_name[0].item_name
      temp[row].item_id_value = {
        label: item_name[0].label,
        value: item_name[0].value,
      }
      // temp[row].price = item_name[0].wholesale_price;
      temp[row].unit = item_name[0].item_units[0]?.unit_from
      temp[row].item_unit_id = item_name[0].item_units[0]?.id
      temp[row].unit_value =
        item_name[0].item_units[0]?.unit_from +
        "|" +
        item_name[0].item_units[0]?.id
      temp[row].name = null
      temp[row].current_qty = item_name[0].current_qty
      temp[row].item_units = item_name[0].item_units

      const prices = []

      temp[row].has_item_price =
        item_name[0].has_item_price === 1 ? true : false
      temp[row].price =
        item_name[0].has_item_price === 1
          ? item_name[0].item_units[0]?.wholesale_price
          : 0
      temp[row].price_value = {
        label: item_name[0].item_units[0]?.wholesale_price,
        value: item_name[0].item_units[0]?.wholesale_price,
      }
      item_name[0].item_units.map((data) => {
        if (
          data.wholesale_price !== null &&
          data.wholesale_price !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.wholesale_price,
            value: data.wholesale_price,
          })
        }
        if (data.retail_price !== null && data.retail_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.retail_price,
            value: data.retail_price,
          })
        }
        if (
          data.special_price_1 !== null &&
          data.special_price_1 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_1,
            value: data.special_price_1,
          })
        }
        if (
          data.special_price_2 !== null &&
          data.special_price_2 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_2,
            value: data.special_price_2,
          })
        }
        if (
          data.special_price_3 !== null &&
          data.special_price_3 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_3,
            value: data.special_price_3,
          })
        }
        if (data.cost_price !== null && data.cost_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.cost_price,
            value: data.cost_price,
          })
        }
        // save the item prices in each item array
        temp[row].item_prices = prices
        // setPrices(prices);
      })
      // TO FILTER ITEMS THAT ARE NOT SELECTED
      const filteredOptions = allItems.filter((option) => {
        return !temp.find((item) => item.item_id === option.item_id)
      })
      setFilteredItems(filteredOptions)
    } else if (type === "prices") {
      temp[row].priceValue = { label: "price", value: e }
      temp[row].price = e

      if (parseInt(temp[row].qty) > parseInt(temp[row].current_qty)) {
        toast.error("Quantity exceeds current inventory quantity.", {
          style: toastStyle(),
        })
        toast.error(
          temp[row].item_id.label +
            " current quantity: " +
            temp[row].current_qty,
          {
            style: toastStyle(),
          }
        )
        temp[row].exceed = true
      } else {
        temp[row].exceed = false
      }
    } else {
      const { name, value } = e.target
      temp[row][name] = value
      if (name === "unit") {
        temp[row].unit = value.split("|")[0]
        temp[row].item_unit_id = value.split("|")[1]
        temp[row].unit_value = value
      }
      // if (
      //     name === "qty" ||
      //     name === "discount"
      // ) {
      //     if (parseInt(temp[row].qty) > parseInt(temp[row].current_qty)) {
      //         toast.error(
      //             "Quantity exceeds current inventory quantity.",
      //             {
      //                 style: toastStyle(),
      //             }
      //         );
      //         toast.error(
      //             temp[row].item_id.label +
      //                 " current quantity: " +
      //                 temp[row].current_qty,
      //             {
      //                 style: toastStyle(),
      //             }
      //         );
      //         temp[row].exceed = true;
      //     } else {
      //         temp[row].exceed = false;
      //     }
      // }
    }
    var tempTotal = parseFloat(temp[row].qty) * parseFloat(temp[row].price)
    temp[row].subtotal = parseFloat(tempTotal)
    var tempDiscount =
      tempTotal * (parseFloat(temp[row].discount_percentage) / 100)
    temp[row].amount = (tempTotal - tempDiscount).toString()
    temp[row].discount_amount = tempDiscount.toString()
    setOrderItems(temp)
    setTimeout(() => setIsChanged(false), 1)
  }

  async function handleSubmitInvoice() {
    var errors = validateSalesInvoiceItems(orderItems)
    setItemError(errors)
    if (
      validateSalesInvoice(addDetails, orderItems, setIsError) &&
      Object.keys(errors).length === 0
    ) {
      setIsClicked(true)
      addDetails.status = "incomplete"
      addDetails.attachments = fileList
      const response = await createSalesInvoice(addDetails, orderItems)
      if (response.data) {
        const salesInvoiceId = response.data.sales_invoice_id
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(
          () => navigate(`/wholesaleinvoice/print/${salesInvoiceId}`),
          1000
        )
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
        // setTimeout(() => refreshPage(), 1000);
      }
      setIsClicked(false)
    } else {
      toast.error(
        "Please fill in all fields and check if order quantity is greater than 0",
        { style: toastStyle() }
      )
    }
  }

  async function handleUpdatePI() {
    if (validateSalesInvoice(addDetails, orderItems, setIsError)) {
      setIsClicked(true)
      addDetails.attachments = fileList
      addDetails.prev_files = prevAttachments
      const response = await updateSalesInvoice(addDetails, orderItems)
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        })
        setTimeout(() => navigate("/wholesaleinvoice/print/" + id), 1000)
      } else if (response.error) {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data)
        })
        setIsClicked(false)
      }
      setIsClicked(false)
    } else {
      toast.error(
        "Please fill in all fields and check if order quantity is greater than 0",
        { style: toastStyle() }
      )
    }
  }

  //

  const handleSubmit = () => {
    if (add) handleSubmitInvoice()
    else if (edit) handleUpdatePI()
  }

  /** FOR EDIT - Fetch Sales Invoice Details */
  async function fetchSalesInvoice() {
    const response = await getSalesInvoice({ id: id })
    if (response.data) {
      var data = response.data.data[0]

      data.customer_id_value = {
        label: data.customer_name,
        value: data.customer_id,
      }
      data.branch_id_value = { label: data.branch_name, value: data.branch_id }
      data.release_from_value = {
        label: data.release_from_name,
        value: data.release_from,
      }
      data.release_by_value = {
        label: data.release_by_name,
        value: data.release_by,
      }

      var ordered_items = data.sales_invoice_items.map((item) => {
        var info = item
        info.subtotal = item.amount
        info.item_id_value = { label: item.item_name, value: item.item_id }
        info.price_value = { label: item.price, value: item.price }
        info.unit_value = item.unit + "|" + item.item_unit_id
        info.has_item = item.item_id === null ? false : true
        info.is_old_item = true
        return info
      })

      setAddDetails(data)
      setOrderItems(ordered_items)
      setPrevAttachments(data.sales_invoice_attachments)
      // fetchItemsByBranch(data.branch_id, ordered_items);
    }
  }

  function handlePaymentChange(e) {
    const paymentInfo = { ...addDetails }
    const { name, value } = e.target
    if (name === "service_fee" || name === "delivery_fee") {
      const paymentEdit = { ...addDetails }
      paymentEdit[name] = value
      setAddDetails(paymentEdit)
      setIsChanged(!isChanged)
    }

    if (name === "to_bank_id" || name === "from_bank_id") {
      paymentInfo[name] = value
    } else {
      paymentInfo[name] = value
    }

    setAddDetails(paymentInfo)
  }

  const handleRemove = (selectedFile) => {
    var newlist = fileList.filter((file) => {
      return selectedFile.uid !== file.uid
    })
    setFileList(newlist)
  }

  const handleBeforeUpload = (file) => {
    if (file.size > 2000000) {
      setShowFileExceedModal(true)
    } else {
      //COMPRESSING FILE
      new Compressor(file, {
        quality: 0.6,
        success: (compressedResult) => {
          setFileList([...fileList, compressedResult])
        },
      })
    }
    return false
  }

  function handleRemoveItemAttachment(url) {
    var newList = prevAttachments.filter((data) => {
      return data.file_url !== url
    })
    setPrevAttachments(newList)
    setPreview(false)
  }

  function handleAddNewRow() {
    const newItem = {
      item_id: "",
      name: "",
      qty: "",
      discount: 0,
      unit: "",
      price: "",
      type: "",
      se_id: "0",
    }
    setAdditionalItemList((oldItems) => [...oldItems, newItem])
  }

  function handleDelRow(id) {
    setIsChanged(true)

    const newList = [...additionalItemList]
    newList.splice(id, 1)
    setAdditionalItemList(newList)

    setTimeout(() => setIsChanged(false), 1)
  }

  function handleAddTblChange(e, id) {
    setIsChanged(true)

    const { name, value } = e.target
    var temp = additionalItemList

    if (name === "qty" || name === "price") {
      temp.map((item, index) => {
        if (index === id) {
          item[name] = value
          item.amount = item.qty * item.price
          item.total = item.qty * item.price

          return item
        }
      })
    } else {
      temp.map((item, index) => {
        if (index === id) {
          item[name] = value
          return item
        }
      })
    }
    setAdditionalItemList(temp)
    setTimeout(() => setIsChanged(false), 1)
  }

  async function fetchBranches() {
    setBranches([])
    const response = await getAllBranches()

    if (response.data) {
      let result = response.data.data.map((a) => {
        var info = {}
        info.name = "release_from"
        info.label = a.name
        info.value = a.id
        info.value_variable = "release_from_value"
        return info
      })
      setBranches(result)
    }
  }

  async function fetchCustomers() {
    setCustomers([])
    const response = await getCustomer({})
    if (response.data) {
      var customers = response.data.data.sort((a, b) =>
        a.trade_name > b.trade_name ? 1 : b.trade_name > a.trade_name ? -1 : 0
      )

      var cleanedArray = customers.map((customer) => {
        var info = {}

        info.name = "customer_id"
        info.label = customer.trade_name
        info.value = customer.id
        info.value_variable = "customer_id_value"

        return info
      })
      setCustomers(cleanedArray)
    }
  }

  async function fetchEmployees() {
    setEmployees([])
    const response = await getAllEmployees()
    if (response.data) {
      var cleanedArray = response.data.data.map((data) => {
        var info = {}

        info.name = "release_by"
        info.label = data.first_name + " " + data.last_name
        info.value = data.id
        info.value_variable = "release_by_value"

        return info
      })
      setEmployees(cleanedArray)
    }
  }

  const handleSearchItem = (newValue) => {
    if (newValue.length > 2) {
      //if length of the input is greater than 3, it will call the search api
      handleFetchItems(newValue, setAllItems)
    }
  }

  // new api for searching items
  async function handleFetchItems(value, setAllItems) {
    setAllItems([])
    const response = await getItemPriceByBranch({
      name: value,
      branch_id: addDetails.branch_id,
    })
    if (response.data) {
      var itemsList = response.data.data.map((data) => {
        var info = data
        info.label = data.item_name
        info.value = data.item_id
        info.name = "item_id"
        info.item_name = data.item_name
        // item_unit_id= data.item_unit_id
        info.item_id = data.item_id
        info.unit = data.unit
        info.wholesale_price = data.wholesale_price
        info.retail_price = data.retail_price
        info.special_price_1 = data.special_price_1
        info.special_price_2 = data.special_price_2
        info.special_price_3 = data.special_price_3
        info.cost_price = data.cost_price
        info.current_qty = data.current_qty
        info.item_units = data.item_units

        return info
      })
      setAllItems(itemsList)
    } else {
      response.error?.data?.messages.map((data) => {
        return toast.error(data, {
          style: toastStyle(),
        })
      })
    }
  }

  async function fetchItemsByBranch(branch_id, ordered_items) {
    setAllItems([])
    setFilteredItems([])
    const response = await getItemPriceByBranch(branch_id)

    if (response.data) {
      var data = response.data.data
        .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
        .map((data) => {
          return {
            label: data.item_name,
            value: data.item_id,
            name: "item_id",
            item_name: data.item_name,
            // item_unit_id: data.item_unit_id,
            item_id: data.item_id,
            unit: data.unit,
            wholesale_price: data.wholesale_price,
            retail_price: data.retail_price,
            special_price_1: data.special_price_1,
            special_price_2: data.special_price_2,
            special_price_3: data.special_price_3,
            cost_price: data.cost_price,
            current_qty: data.current_qty,
            item_units: data.item_units,
          }
        })
      setAllItems(data)
      handleSetItemUnitOption(ordered_items, data)
    }
  }

  //to filter item options and set unit dropdown values per item on load
  function handleSetItemUnitOption(items, item_options) {
    var itemList = items?.map((item) => {
      var info = item
      var units = item_options?.filter((data) => data.item_id === item.item_id)
      info.item_units = units[0]?.item_units
      var prices = []
      units[0]?.item_units.map((data) => {
        if (
          data.wholesale_price !== null &&
          data.wholesale_price !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.wholesale_price,
            value: data.wholesale_price,
          })
        }
        if (data.retail_price !== null && data.retail_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.retail_price,
            value: data.retail_price,
          })
        }
        if (
          data.special_price_1 !== null &&
          data.special_price_1 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_1,
            value: data.special_price_1,
          })
        }
        if (
          data.special_price_2 !== null &&
          data.special_price_2 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_2,
            value: data.special_price_2,
          })
        }
        if (
          data.special_price_3 !== null &&
          data.special_price_3 !== "0.0000"
        ) {
          prices.push({
            name: "price",
            label: data.special_price_3,
            value: data.special_price_3,
          })
        }
        if (data.cost_price !== null && data.cost_price !== "0.0000") {
          prices.push({
            name: "price",
            label: data.cost_price,
            value: data.cost_price,
          })
        }
        // save the item prices in each item array
        info.item_prices = prices
        // setPrices(prices);
      })
      return info
    })
    setOrderItems(itemList)

    const filteredOptions = item_options.filter((option) => {
      return !items.find((item) => item.item_id === option.item_id)
    })
    setFilteredItems(filteredOptions)
  }

  //DISABLE SCROLL FUNCTION
  function limitScroll() {
    var numericInputs = document.querySelectorAll(".numeric-input")
    numericInputs.forEach(function (input) {
      input.addEventListener("wheel", function (e) {
        e.preventDefault()
      })
    })
  }
  limitScroll()

  async function fetchBanks() {
    const response = await getAllBanks()
    if (response.data) {
      if (response.data.status === "success") {
        setBanks(response.data.data)
      }
    }
  }

  /** FOR EDIT - Fetch Sales Invoice Details */
  async function fetchSalesOrder() {
    setIsChanged(true)
    const response = await getSalesOrder({ id: id })
    if (response.data) {
      var data = response.data.data[0]

      data.customer_id_value = {
        label: data.customer_name,
        value: data.customer_id,
      }

      data.branch_id_value = { label: data.branch_name, value: data.branch_id }
      data.release_from_value = {
        label: data.branch_name,
        value: data.branch_id,
      }

      data.release_from = data.branch_id
      data.is_vat = data.vat_type === "VAT" ? true : false
      data.withholding_percentage = parseInt(data.withholding_percentage)
      data.original_withholding_percentage = parseInt(
        data.withholding_percentage
      )

      var ordered_items = data.sales_order_items.map((item) => {
        var info = item
        info.amount = item.amount
        info.subtotal = item.amount
        info.qty = item.remaining_qty
        info.unit_value = item.unit + "|" + item.item_unit_id
        info.item_id_value = { label: item.item_name, value: item.item_id }
        info.price_value = { label: item.price, value: item.price }
        info.has_item = item.item_id === null ? false : true
        info.is_old_item = true
        return info
      })

      var _discount_total = ordered_items
        .map((item) => parseFloat(item.discount_amount))
        .reduce((a, b) => a + b, 0)

      data.discount_total = _discount_total

      setAddDetails(data)
      setOrderItems(ordered_items)
      // to fetch items and set the filtered items
      // fetchItemsByBranch(data.branch_id, ordered_items);
    }
    setTimeout(() => setIsChanged(false), 100)
  }

  // DATA FETCHING
  useEffect(() => {
    if (edit) {
      fetchSalesInvoice()
    } else if (add && id) {
      fetchSalesOrder()
    }
    fetchBranches()
    fetchCustomers()
    fetchBanks()
    fetchEmployees()
  }, [])

  // useEffect(() => {
  //     fetchItemsByBranch(addDetails.branch_id);
  // }, [addDetails.branch_id]);

  // FOR DYNAMIC CALCULATION
  useEffect(() => {
    var calcSubtotal = 0
    var calcDiscountSubtotal = 0
    var tempDiscount = addDetails.discount ? parseFloat(addDetails.discount) : 0
    var tempServiceFee = addDetails.service_fee
      ? parseFloat(addDetails.service_fee)
      : 0

    var itemListSubtotal = orderItems
      .map((item) => parseFloat(item.amount))
      .reduce((a, b) => a + b, 0)

    // item subtotal with discount per item
    calcSubtotal = itemListSubtotal
    // item subtotal minus discount
    calcDiscountSubtotal = calcSubtotal - tempDiscount

    var _wht = 0
    var vatable_sales = 0
    var vat = 0

    if (addDetails.vat_type === "VAT") {
      vatable_sales = parseFloat(calcDiscountSubtotal) / 1.12
      vat = parseFloat(calcDiscountSubtotal) - vatable_sales
      var percentage =
        addDetails?.withholding_percentage === 1
          ? 0.01
          : addDetails?.withholding_percentage === 2
          ? 0.02
          : 0

      // witholding tax if vat is checked
      var tempVatSales = vatable_sales ? parseFloat(vatable_sales) : 0
      var tempWHTPercentage = percentage ? parseFloat(percentage) : 0
      _wht = parseFloat(tempVatSales) * tempWHTPercentage
    }
    var _grand_total_without_fee = calcDiscountSubtotal - _wht

    setAddDetails((prev) => {
      return {
        ...prev,
        grand_total: _grand_total_without_fee + tempServiceFee,
        // grand_total: calcSubtotal + tempServiceFee - tempDiscount,
        subtotal: calcSubtotal.toFixed(2),
        withholding_tax: _wht,
        discounted_subtotal: calcDiscountSubtotal.toFixed(2),
        grandtotal_without_service_fee: _grand_total_without_fee,
        vat: vat,
        vatable_sales: vatable_sales,
      }
    })
  }, [isChanged])

  console.log(orderItems)

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"WHOLESALE"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {add ? "ADD SALES INVOICE" : "EDIT SALES INVOICE"}
            </h1>
          </Col>
        </Row>

        {/* content */}
        <div className="edit-form">
          {/* FRANCHISEE SALES INVOICE DETAILS */}
          <Fragment>
            <Row className="mb-3">
              <Col xs={12} lg={4}>
                <span className="edit-label">
                  Customer
                  <span className="color-red"> *</span>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Customer..."
                  value={addDetails.customer_id_value}
                  options={customers}
                  onChange={(e) => handleSelectChange(e)}
                />
              </Col>
              <Col xs={12} lg={4}>
                <span className="edit-label">Customer PO No.</span>
                <Form.Control
                  type="text"
                  name="customer_po_no"
                  className="nc-modal-custom-text"
                  value={
                    addDetails.customer_po_no !== "undefined"
                      ? addDetails.customer_po_no
                      : ""
                  }
                  disabled="false"
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Credit Limit
                  <span className="color-red"> *</span>
                </span>
                <Form.Control
                  type="text"
                  name="customer_credit_limit"
                  value={addDetails.customer_credit_limit}
                  className="nc-modal-custom-text"
                  disabled
                />
              </Col>
              {/* <Col xs={3}>
                                <Form.Control
                                    type="date"
                                    name="order_date"
                                    className="nc-modal-custom-text"
                                    defaultValue={
                                        addDetails.order_date
                                    }
                                    onChange={(e) => handleAddChange(e)}
                                />
                            </Col> */}
            </Row>
            <Row className="mb-3">
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Branch
                  <span className="color-red"> *</span>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Select Branch..."
                  value={addDetails.branch_id_value}
                  options={branches}
                  onChange={(e) => handleSelectChange(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">Sales Date</span>
                <span className="color-red"> *</span>
                <Form.Control
                  type="date"
                  name="sales_date"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.sales_date}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Delivery Date
                  <span className="color-red"> *</span>
                </span>
                <Form.Control
                  type="date"
                  name="delivery_date"
                  className="nc-modal-custom-text"
                  defaultValue={addDetails.delivery_date}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">
                  Release From
                  <span className="color-red"> *</span>
                </span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Release From..."
                  value={addDetails.release_from_value}
                  options={branches}
                  onChange={(e) => handleSelectChange(e)}
                />
                <InputError
                  isValid={isError.release_from}
                  message={"Release from is required"}
                />
              </Col>
              <Col xs={12} lg={3} className="mt-4 mt-lg-0">
                <span className="edit-label">Release By</span>
                <span className="color-red"> *</span>
                <Select
                  className="react-select-container"
                  classNamePrefix="react-select"
                  placeholder="Release By..."
                  value={addDetails.release_by_value}
                  options={employees}
                  onChange={(e) => handleSelectChange(e)}
                />
                <InputError
                  isValid={isError.release_by}
                  message={"Release by is required"}
                />
              </Col>
              <Col xs={12} lg={5}>
                <span className="edit-label">
                  Delivery Address
                  <span className="color-red"> *</span>
                </span>
                <Form.Control
                  type="text"
                  name="address"
                  value={addDetails.address}
                  className="nc-modal-custom-text"
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.address}
                  message={"Franchisee Branch is required"}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} lg={4}>
                <span className="edit-label">Contact No.</span>
                <Form.Control
                  type="text"
                  name="contact_no"
                  value={addDetails.contact_no}
                  className="nc-modal-custom-text"
                  onChange={(e) => handleAddChange(e)}
                />
                <InputError
                  isValid={isError.contact_no}
                  message={"Franchisee Branch is required"}
                />
              </Col>
              <Col xs={12} lg={4}>
                <span className="edit-label">Invoice No.</span>
                <Form.Control
                  type="text"
                  name="invoice_no"
                  className="nc-modal-custom-text"
                  value={addDetails.invoice_no}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
              <Col xs={12} lg={4} className="mt-lg-0">
                <span className="edit-label">Transfer Slip No.</span>
                <Form.Control
                  type="text"
                  name="transfer_slip_no"
                  className="nc-modal-custom-text"
                  value={addDetails.transfer_slip_no}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs={12} lg={4} className="mt-4 mt-lg-0">
                <span className="edit-label">Remarks</span>
                <Form.Control
                  type="text"
                  name="remarks"
                  className="nc-modal-custom-text"
                  value={addDetails.remarks}
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
          </Fragment>

          {/* ORDER ITEMS */}
          <Row className="mt-3 pt-3">
            <Col>
              <span className="edit-label mb-2">
                Choose Items to Order
                <span className="color-red"> *</span>
              </span>
              <div className="edit-purchased-items">
                {orderItems.length !== 0 ? (
                  <Table>
                    <thead>
                      <tr>
                        <th className="color-gray">item</th>
                        <th className="color-gray">quantity</th>
                        <th className="color-gray">unit</th>
                        {/* <th className="color-gray">
                                                    qty received
                                                </th> */}
                        {/* <th className="color-gray">
                                                    item code
                                                </th> */}
                        <th className="color-gray">price</th>
                        <th className="color-gray">discount</th>
                        <th className="color-gray">total</th>
                        <th className="color-gray">remarks</th>
                        <th className="color-gray">actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {orderItems.map((item, index) => {
                        return (
                          <tr>
                            <td>
                              <Form.Control
                                type="text"
                                placeholder="Description"
                                className="nc-modal-custom-input mb-1 w-full"
                                name="description"
                                value={item.description}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index)
                                }
                                disabled={item.has_item}
                              />
                              <InputError
                                isValid={isError.description}
                                message={"Description is required"}
                              />
                              {item.has_item ? (
                                <Form.Control
                                  type="text"
                                  name="item_id"
                                  className="nc-modal-custom-input mb-1 w-full"
                                  value={item.item_name}
                                  placeholder="Item Name"
                                  disabled
                                />
                              ) : (
                                <>
                                  <SearchBox
                                    showSearch
                                    value={item.item_id_value}
                                    placeholder={"Search Item..."}
                                    className="react-select-container"
                                    dropdownClassName="z-large antdesign-custom-dropdown w-full"
                                    style={antdesignSelectStyle}
                                    defaultActiveFirstOption={false}
                                    suffixIcon={null}
                                    filterOption={false}
                                    onSearch={handleSearchItem}
                                    onChange={(e) =>
                                      handleOrderItemsChange(
                                        e,
                                        index,
                                        "item_id"
                                      )
                                    }
                                    notFoundContent={null}
                                    options={(allItems || []).map((d) => ({
                                      value: d.value,
                                      label: d.label,
                                    }))}
                                  />
                                  {itemError[index] &&
                                    itemError[index].item_id && (
                                      <div className="validity-error callout bottom">
                                        {itemError[index].item_id}
                                      </div>
                                    )}
                                </>
                              )}
                              {item.exceed ? <p></p> : ""}
                            </td>
                            <td>
                              <Form.Control
                                type="number"
                                name="qty"
                                className="hide-spinner numeric-input"
                                min={1}
                                value={item.qty}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index)
                                }
                              />
                              {item.exceed ? (
                                <h7 className="red">Quantity exceeds</h7>
                              ) : (
                                ""
                              )}
                              {itemError[index] && itemError[index].qty && (
                                <div className="validity-error callout bottom">
                                  {itemError[index].qty}
                                </div>
                              )}
                            </td>
                            <td>
                              {item.item_id === "" ||
                              item.item_id === undefined ||
                              item.item_id === null ||
                              item.is_old_item ? (
                                <Form.Control
                                  type="text"
                                  name="unit"
                                  value={item.unit}
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                />
                              ) : (
                                <Form.Select
                                  name="unit"
                                  id={item.id}
                                  value={item.unit_value}
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                >
                                  <option value="">Select</option>
                                  {item.item_units?.map((data) => {
                                    return (
                                      <option
                                        value={data.unit_from + "|" + data.id}
                                      >
                                        {data.unit_from}
                                      </option>
                                    )
                                  })}
                                </Form.Select>
                              )}
                              {/* <Form.Control
                                                                type="text"
                                                                name="unit"
                                                                disabled
                                                                value={
                                                                    item.unit
                                                                }
                                                                onChange={(e) =>
                                                                    handleOrderItemsChange(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            /> */}
                              {item.exceed ? <p></p> : ""}
                            </td>
                            {/* <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="qty_received"
                                                                value={item.qty_received}
                                                                onChange={(e) =>handleOrderItemsChange(e, index)}
                                                            />
                                                        </td> */}
                            <td>
                              {item.has_item_price ? (
                                <>
                                  <SearchBox
                                    value={item.price}
                                    placeholder={"Select Price..."}
                                    className="react-select-container w-full"
                                    dropdownClassName="z-large antdesign-custom-dropdown"
                                    style={antdesignSelectStyle}
                                    defaultActiveFirstOption={false}
                                    suffixIcon={null}
                                    filterOption={false}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index, "prices")
                                    }
                                    notFoundContent={null}
                                    options={item.item_prices}
                                  />
                                  {/* <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder="Select price..."
                                    value={item.price_prices}
                                    options={item.item_prices}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index, "prices")
                                    }
                                  /> */}
                                  {itemError[index] &&
                                    itemError[index].price && (
                                      <div className="validity-error callout bottom">
                                        {itemError[index].price}
                                      </div>
                                    )}
                                  {item.exceed ? <p></p> : ""}
                                </>
                              ) : (
                                <>
                                  <Form.Control
                                    type="number"
                                    name="price"
                                    className="hide-spinner numeric-input"
                                    min={1}
                                    placeholder={item.price}
                                    // value={item.amount}
                                    onChange={(e) =>
                                      handleOrderItemsChange(e, index)
                                    }
                                  />
                                  {itemError[index] &&
                                    itemError[index].price && (
                                      <div className="validity-error callout bottom">
                                        {itemError[index].price}
                                      </div>
                                    )}
                                </>
                              )}
                            </td>
                            <td>
                              <div className="d-flex flex-row justify-content-center align-items-center gap-1">
                                <Form.Control
                                  className="mb-1"
                                  type="number"
                                  name="discount_percentage"
                                  value={formatDecimal(
                                    item.discount_percentage
                                  )}
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                />
                                <p className="pt-1 fs-6">%</p>
                              </div>
                              <div className="d-flex flex-row justify-content-center align-items-center gap-1">
                                <Form.Control
                                  type="number"
                                  name="discount_amount"
                                  value={formatDecimal(item.discount_amount)}
                                  onChange={(e) =>
                                    handleOrderItemsChange(e, index)
                                  }
                                  disabled
                                />
                                <p className="pt-1 fs-6">₱</p>
                              </div>
                            </td>
                            <td className="color-green">
                              {numberFormat(item.amount)}
                              {item.exceed ? <p></p> : ""}
                            </td>
                            <td>
                              <Form.Control
                                type="text"
                                name="item_remarks"
                                value={item.item_remarks}
                                onChange={(e) =>
                                  handleOrderItemsChange(e, index)
                                }
                              />
                            </td>
                            <td className="text-center">
                              <img
                                alt="delete"
                                src={trash}
                                onClick={() => deleteOrder(index)}
                                className="cursor-pointer"
                              />
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                ) : (
                  <div className="entries-not-found">
                    There is no ordered items yet.
                  </div>
                )}
              </div>
              <InputError
                isValid={isError.list}
                message={"Please add an item or additional item"}
              />
            </Col>
          </Row>

          {/* ADD ITEM BUTTON */}
          <Row className="pt-3 PO-add-item">
            <Col xs={12} lg={3}>
              <Button
                type="button"
                disabled={!addDetails.branch_id}
                onClick={() => addNewOrder()}
              >
                Add Item
              </Button>
            </Col>
          </Row>
          {edit && (
            <>
              <div className="mt-4 noPrint mx-3">
                <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
                <Row className="">
                  {prevAttachments &&
                    prevAttachments.map((attachment) => (
                      <Col
                        xs={1}
                        onClick={() => {
                          setPreviewFile(attachment.file_url)
                          setPreview(true)
                        }}
                        className="cursor-pointer preview-container"
                      >
                        <img
                          src={attachment.file_url}
                          className="img-preview"
                          alt=""
                        />
                      </Col>
                    ))}
                  {!prevAttachments ||
                    (prevAttachments.length === 0 && (
                      <Col xs={1}>
                        <div className="no-data-cont d-flex justify-content-left preview-container">
                          <img
                            src={noDataImg}
                            alt="no data found"
                            className="img-preview"
                          />
                        </div>
                      </Col>
                    ))}
                </Row>
              </div>
            </>
          )}
          <Row className="mt-4 mb-2">
            <Col>
              <Dragger
                fileList={fileList}
                onRemove={handleRemove}
                beforeUpload={handleBeforeUpload}
                multiple={false}
                listType="picture"
                progress={{ showInfo: true }}
              >
                <img src={upload} className="cursor-pointer" alt="" />
                <p className="ant-upload-text">
                  Click or drag file to this area to upload
                </p>
              </Dragger>
            </Col>
          </Row>

          {/* <Row className="mt-4 pt-3">
                        <span className="edit-label mb-2">
                            Additional Order Items
                        </span>
                        <div className="edit-purchased-items">
                            {additionalItemList.length !== 0 ? (
                                <Table>
                                    <thead>
                                        <tr>
                                            <th className="color-gray">item</th>
                                            <th className="color-gray">
                                                quantity
                                            </th>
                                            <th className="color-gray">unit</th>
                                            <th className="color-gray">
                                                unit price
                                            </th>
                                            <th className="color-gray">
                                                amount
                                            </th>
                                            <th className="color-gray">
                                                actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {additionalItemList.map(
                                            (item, index) => {
                                                return (
                                                    <tr>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="name"
                                                                value={
                                                                    item.name
                                                                }
                                                                onChange={(e) =>
                                                                    handleAddTblChange(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                            <InputError
                                                                isValid={isError.item_name}
                                                                message={"Item is required"}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                name="qty"
                                                                className="hide-spinner numeric-input"
                                                                min={1}
                                                                value={
                                                                    item.qty
                                                                }
                                                                onChange={(e) =>
                                                                    handleAddTblChange(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                            <InputError
                                                                isValid={isError.qty2}
                                                                message={"Quantity is required"}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                name="unit"
                                                                value={
                                                                    item.unit
                                                                }
                                                                onChange={(e) =>
                                                                    handleAddTblChange(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                name="price"
                                                                className="hide-spinner numeric-input"
                                                                value={
                                                                    item.price
                                                                }
                                                                onChange={(e) =>
                                                                    handleAddTblChange(
                                                                        e,
                                                                        index
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td className="color-green">
                                                            {item.qty &&
                                                            item.price
                                                                ? numberFormat(
                                                                      item.price *
                                                                          item.qty
                                                                  )
                                                                : "0.00"}
                                                        </td>
                                                        <td className="text-center">
                                                            <img
                                                                alt="delete"
                                                                src={trash}
                                                                onClick={() =>
                                                                    handleDelRow(
                                                                        index
                                                                    )
                                                                }
                                                                className="cursor-pointer"
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </tbody>
                                </Table>
                            ) : (
                                <div className="entries-not-found">
                                    There is no additional purchased items
                                    recorded yet.
                                </div>
                            )}
                        </div>
                    </Row> 
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => handleAddNewRow()}>
                            Add Item
                        </Button>
                    </Row> */}

          <Fragment>
            {/* SUBTOTAL, FREIGHT COST, DISCOUNT, & GRAND TOTAL */}
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Subtotal</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {numberFormat(addDetails.subtotal)}
                </span>
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Discount</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="number"
                  name="discount"
                  value={addDetails.discount}
                  className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                  onChange={(e) => handleAddChange(e)}
                />
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">
                  Discounted Subtotal
                </span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {numberFormat(addDetails.discounted_subtotal)}
                </span>
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={5} lg={6}></Col>
              <Col xs={3} lg={1} className="text-end print-table-footer-label">
                <Form.Group className="" controlId="formBasicCheckbox">
                  <Form.Check
                    type="checkbox"
                    label="VAT"
                    name="is_vat"
                    className="pt-2"
                    checked={addDetails.vat_type === "VAT"}
                    onChange={(e) => handleAddChange(e)}
                    disabled
                  />
                </Form.Group>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end print-table-footer-data ps-4">
                {addDetails.vat ? numberFormat(addDetails.vat) : "0.00"}
              </Col>
            </Row>
            {addDetails.vat_type === "VAT" && (
              <>
                <Row className="align-right pt-3">
                  <Col xs={8} className="text-end print-table-footer-label">
                    Vatable Sales
                  </Col>
                  <Col xs={1} className="text-end">
                    <span className="edit-label align-middle">PHP</span>
                  </Col>
                  <Col xs={3} className="text-end print-table-footer-data ps-4">
                    {addDetails.vatable_sales
                      ? numberFormat(addDetails.vatable_sales)
                      : "0.00"}
                  </Col>
                </Row>
                <Row className="align-right pt-3">
                  <Col
                    xs={2}
                    lg={3}
                    className="text-end pt-2 print-table-footer-label"
                  >
                    WHT
                  </Col>
                  <Col
                    xs={3}
                    lg={1}
                    className="text-end print-table-footer-label"
                  >
                    <Form.Group className="" controlId="formBasicCheckbox">
                      <Form.Check
                        type="radio"
                        label="1%"
                        name="withholding_percentage"
                        value="1"
                        className="pt-2"
                        style={{ marginLeft: "2rem" }}
                        checked={addDetails.withholding_percentage === 1}
                        onChange={(e) => handleAddChange(e)}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col
                    xs={3}
                    xl={1}
                    className="text-end print-table-footer-label"
                  >
                    <Form.Group className="" controlId="formBasicCheckbox">
                      <Form.Check
                        type="radio"
                        label="2%"
                        name="withholding_percentage"
                        value="2"
                        className="pt-2"
                        style={{ marginLeft: "2rem" }}
                        checked={addDetails.withholding_percentage === 2}
                        onChange={(e) => handleAddChange(e)}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={1} className="text-end">
                    <span className="edit-label align-middle">PHP</span>
                  </Col>
                  <Col xs={3} className="text-end print-table-footer-data ps-4">
                    {addDetails.withholding_tax
                      ? numberFormat(addDetails.withholding_tax)
                      : "0.00"}
                  </Col>
                </Row>
              </>
            )}
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Grand Total</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {addDetails.grandtotal_without_service_fee
                    ? numberFormat(addDetails.grandtotal_without_service_fee)
                    : "0.00"}
                </span>
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Service Fee</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3}>
                <Form.Control
                  type="number"
                  name="service_fee"
                  value={addDetails.service_fee}
                  className="align-middle nc-modal-custom-text hide-spinner numeric-input"
                  onChange={(e) => {
                    handleAddChange(e)
                  }}
                />
              </Col>
            </Row>
            <Row className="align-right pt-3">
              <Col xs={8} className="text-end">
                <span className="edit-label color-gray">Total Amount Due</span>
              </Col>
              <Col xs={1} className="text-end">
                <span className="edit-label align-middle">PHP</span>
              </Col>
              <Col xs={3} className="text-end">
                <span className="edit-label align-middle">
                  {addDetails.grand_total
                    ? numberFormat(addDetails.grand_total)
                    : "0.00"}
                </span>
              </Col>
            </Row>
          </Fragment>

          {/* FOOTER: CANCEL & SUBMIT BUTTONS */}
          <div className="d-flex justify-content-end pt-5 pb-3">
            <button
              type="button"
              className="button-secondary me-3"
              onClick={() => navigate("/wholesaleinvoice")}
            >
              Cancel
            </button>
            {isClicked ? (
              <div className="button-primary d-flex justify-content-center">
                <ReactLoading
                  type="bubbles"
                  color="#FFFFFF"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <button
                type="button"
                className="button-primary"
                onClick={handleSubmit}
              >
                Save Invoice
              </button>
            )}
          </div>
        </div>
      </div>
      <Footer />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <Row className="justify-content-center">
          <img
            alt="attachment"
            style={{
              width: "100%",
            }}
            src={previewFile}
          />
          <div className="mt-2 d-flex justify-content-center">
            <img
              src={trash}
              alt="trash"
              onClick={() => handleRemoveItemAttachment(previewFile)}
              className="cursor-pointer"
            />
          </div>
        </Row>
      </Modal>
      <FileExceedModal
        show={showFileExceedModal}
        onHide={() => setShowFileExceedModal(false)}
        size="2MB"
      />
    </div>
  )
}

export default SalesInvoiceForm
